import 'react-phone-number-input/style.css';
import { StyledPhoneInput } from './styled';
import { StyledInputLabel } from '../Input/styled';
import { FormControl } from '@mui/material';
import { ThemedComponent } from 'ui/theme';
import PropTypes from 'prop-types';
import { InputRequired } from 'ui/styled';

const PhoneInput = ({ value, onChange, placeholder, onBlur, disabled, required }) => {
  return (
    <>
      <ThemedComponent>
        <FormControl fullWidth variant="standard">

          {placeholder && (
            <StyledInputLabel htmlFor="phone-input" shrink>
              {placeholder}
              <InputRequired>{ required ? "*" : "" }</InputRequired>
            </StyledInputLabel>
          )}
          <StyledPhoneInput
            international
            defaultCountry="US"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            placeholder={placeholder || "Enter phone number"}
            id="phone-input"

          />
        </FormControl>
      </ThemedComponent>
    </>
  );
};

PhoneInput.propTypes = {
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
};

PhoneInput.defaultProps = {
  value: '',
  placeholder: '',
  onBlur: undefined,
  disabled: false,
};

export default PhoneInput;
